import * as React from 'react';

const BannerContext = React.createContext({
  currentBanner: '',
  handleBannerClose: () => {
    /* this initial context should never be used */
  },
  showCurrentBanner: false,
  isBannerClosing: false,
});

export default BannerContext;
